import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useUser } from 'context/UserContext'
import { ContinueButton } from 'components/ContinueButton'

interface Props {
  nextRoute: string
}

export const MeditationMovement: React.FC<Props> = ({ nextRoute }) => {
  const { t } = useTranslation('translation', {
    useSuspense: false,
  })

  const { user } = useUser()

  const navigate = useNavigate()

  const onContinue = () => {
    navigate(nextRoute)
  }

  const genderBasedImage =
    user.gender === 'm'
      ? '/images/meditation_movement_male.jpg'
      : '/images/meditation_movement_female.jpg'

  return (
    <div className="flex flex-col">
      <div className="relative w-full">
        <img
          alt="Meditation Movement"
          className="max-h-[250px] w-full object-cover"
          src={genderBasedImage}
        />

        <div className="absolute top-1/4 left-1/2 flex w-full -translate-x-1/2 -translate-y-1/4 transform flex-col items-center pt-20 md:pt-10">
          <img
            src="/images/1_number.png"
            alt="Number 1"
            className="max-w-[10%]"
          />
          <p className="mt-2 font-title text-3xl text-white md:text-6xl">
            {t('meditation_pages.movement.title')}
          </p>
        </div>
      </div>
      <div className="flex flex-col px-5 pt-24">
        <p
          className="text-center font-body text-sm text-ar-dark-gray"
          dangerouslySetInnerHTML={{
            __html: t('meditation_pages.movement.text', {
              interpolation: { escapeValue: false },
            }),
          }}
        />
      </div>

      <ContinueButton onClick={onContinue} />
    </div>
  )
}
